import { isString } from "lodash-es";
import { useMemo } from "react";

export const useSortObjectArray = <T extends object, Key extends keyof T>(
  items: T[],
  key: Key,
) =>
  useMemo(
    () =>
      items.toSorted((a, b) => {
        if (isString(a[key]) && isString(b[key])) {
          return a[key].localeCompare(b[key]);
        } else {
          return a[key] > b[key] ? 1 : -1;
        }
      }),
    [items, key],
  );
